<template>
  <div>
    <widgets-dialogs
      ref="widgetDialogs"
      :widgets="form.widgets"
      :errors="errors.widgets"
    />
    <revisions-dialog ref="revisionsDialog" @submit="loadRevision" />
    <revisions-alert :pendingRevision="pendingRevision" />
    <form-wrapper @submit="onSubmit">
      <div slot="box" v-loading="loading">
        <component-compiler
          v-for="(component, i) in getFields()"
          :content="component"
          :key="`form-${i}`"
        />
      </div>
      <form-nav
        :loading="loading"
        slot="navbar"
        :show-language-switcher="showLanguageSwitcher"
      >
        <component-compiler
          v-for="(component, i) in getNavButtons()"
          :content="component"
          :key="`nav-button-${i}`"
        />
      </form-nav>
    </form-wrapper>
  </div>
</template>
<script>
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import WidgetsDialogs from '@/components/widgets/WidgetsDialogs'
import LivePreviewMixin from '@/crudBases/form/LivePreviewMixin'
import RevisionsDialog from '@/components/revisions/RevisionsDialog'
import RevisionsMixin from '@/crudBases/form/RevisionsMixin'
import RevisionsAlert from '@/crudBases/form/RevisionsAlert'
import { get } from 'lodash'

export default {
  extends: FormMixin,
  mixins: [LivePreviewMixin, RevisionsMixin],
  components: {
    WidgetsDialogs,
    RevisionsDialog,
    RevisionsAlert
  },
  data() {
    return {
      selectedTab: 'general',
      form: {
        widgets: []
      }
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler() {
        this.fetchPreview()
      }
    },
    'form.use_redirect'(value) {
      if (value && this.selectedTab !== 'general') {
        this.selectedTab = 'general'
      }
    }
  },
  computed: {
    revisionsAvailable() {
      return this.lookupParams
    },
    url() {
      const selectedLanguage = this.$store.state.selectedLanguage
      const parentSlug = get(this, [
        'form',
        'parent_obj',
        `slug_${selectedLanguage}`
      ])
      const currentPageSlug = get(this, ['form', `slug_${selectedLanguage}`])

      let path = `/${currentPageSlug}/`
      if (typeof parentSlug === 'string') {
        path = `/${parentSlug}` + path
      }
      return process.env.VUE_APP_FRONTEND_URL + path
    },
    isRedirectMode() {
      return !!get(this, ['form', 'use_redirect'])
    }
  },
  methods: {
    getNavButtons() {
      const buttons = [
        {
          component: 'router-link',
          attrs: {
            to: { ...this.redirectRoute, query: this.$route.query }
          },
          condition: this.redirectRoute,
          children: [
            {
              component: 'el-button',
              innerText: 'Cancel'
            }
          ]
        }
      ]

      if (this.revisionsAvailable) {
        buttons.push(this.getRevisionsDropdown())
      } else {
        buttons.push({
          component: 'el-button',
          attrs: {
            type: 'primary'
          },
          listeners: {
            click: this.onSubmit
          },
          innerText: 'Submit'
        })
      }

      return buttons
    },
    getFields() {
      const previewTab = this.getPreviewTab()
      previewTab.props = {
        ...(previewTab.props || {}),
        disabled: this.isRedirectMode || get(previewTab, ['props', 'disabled'])
      }

      return [
        {
          component: 'el-tabs',
          attrs: {
            stretch: true,
            value: this.selectedTab
          },
          listeners: {
            input: value => (this.selectedTab = value)
          },
          children: [
            this.getGeneralTab(),
            previewTab,
            this.getWidgetsTab(),
            this.getSEOTab()
          ]
        }
      ]
    },
    getGeneralTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'General',
          name: 'general'
        },
        children: this.getGeneralFields()
      }
    },
    getWidgetsTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Widgets'
        },
        props: {
          disabled: this.isRedirectMode
        },
        children: [new fields.Widgets({ modelPath: [this, 'form', 'widgets'] })]
      }
    },
    getGeneralFields() {
      return []
    },
    getSEOTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'SEO'
        },
        props: {
          disabled: this.isRedirectMode
        },
        children: [
          new fields.Input({
            label: 'Slug',
            modelPath: [this, 'form', 'slug'],
            multilingual: true,
            condition: !!this.form.id
          }),
          new fields.Input({
            label: 'URL',
            modelPath: [this, 'url'],
            disabled: true,
            condition: !!this.form.id
          }),
          new fields.Input({
            label: 'Page meta title for search engines (Google, Bing etc.)',
            modelPath: [this, 'form', 'meta_title'],
            multilingual: true
          }),
          new fields.Input({
            label:
              'Page meta description for search engines (Google, Bing etc.)',
            modelPath: [this, 'form', 'meta_description'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Input({
            label: 'Facebook meta title',
            modelPath: [this, 'form', 'og_title'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Facebook meta description',
            modelPath: [this, 'form', 'og_description'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Image({
            label: 'Facebook image',
            modelPath: [this, 'form', 'og_image'],
            onlyShowNormalCrop: true
          })
        ]
      }
    }
  }
}
</script>
